import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export const useExportTextingReportMutation = ({
	onError,
	onSuccess,
	impersonationContext,
	includeAll,
}: {
	onSuccess?: (data: Api.ISystemJob) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
	impersonationContext?: Api.IImpersonationContext;
	includeAll?: boolean;
} = {}) => {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: (request: Api.TextMessagesExportRequest) => {
			return userSession.webServiceHelper.callAsync<Api.ISystemJob>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: 'reports/texting/export',
					queryParams: { includeAll },
					impersonationContext,
				}),
				'POST',
				request
			);
		},
		onError,
		onSuccess,
	});
};
